module.exports = __webpack_public_path__ + "img/icon10.07c7781b.png";